import { customAxios } from "./customAxios";

/**
 * 진단결과 목록(MGMT)
 * @param {*} query 
 * @returns 
 */
export const getMgmtDiagnosisResultsByQuery = async(query)=>{
  const res = await customAxios.get('/api/mgmt/diagnosis/result', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 진단결과 상세(MGMT)
 * @param {*} id 
 * @returns 
 */
export const getMgmtDiagnosisResultsById = async(id)=>{
  const res = await customAxios.get('/api/mgmt/diagnosis/result/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}
